import gql from 'graphql-tag';

export const FACEBOOK_ACCOUNTS_QUERY = gql`
  query FacebookAccountsQuery($filter: FacebookAccountsFilterInput!) {
    facebookAccounts(filter: $filter) {
      id
      name
      accountId
      businessIdType
    }
  }
`;
